const initialState = {
    userPermissions: [],
    userPermissionsProfile: {},
    isReadingUserPermissions: false,
    isReadingRole: false,
    isUpdatingRole: false,
    roleBeingDeleted: null,
};

export default initialState;
